export default __webpack_public_path__ + "static/media/roompage-table-status.a7c72841.svg";